<section class="history-dialog">
  <div class="history-heading">
    <div class="history-heading-icon"><i class="pi pi-history"></i></div>
    <div class="history-heading-copy">
      <h2>Ultime attività</h2>
      <p>Registro delle operazioni di {{ userName }}.</p>
    </div>
    <span class="history-count">{{ total }} attività</span>
  </div>

  <div class="history-toolbar">
    <span class="p-input-icon-left history-search">
      <i class="pi pi-search"></i>
      <input pInputText type="text" [(ngModel)]="search"
        (ngModelChange)="onSearchChange()" placeholder="Cerca attività..."
        aria-label="Cerca nello storico" />
    </span>
    <button pButton type="button" icon="pi pi-refresh" label="Aggiorna"
      class="p-button-outlined" (click)="loadAccesses()" [disabled]="loading"></button>
  </div>

  <div class="history-table-wrap">
    <div *ngIf="loading" class="history-loading" role="status" aria-live="polite">
      <img src="assets/icons/loading-spinner.svg" class="history-loading-logo" alt="" aria-hidden="true" />
      <span>Caricamento attività...</span>
    </div>
    <p-table [value]="pageAccesses" styleClass="history-table" [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 15%">Response Headers</th>
          <th style="width: 10%">Categoria</th>
          <th style="width: 12%">Path</th>
          <th style="width: 9%">Metodo</th>
          <th style="width: 9%">Codice</th>
          <th style="width: 19%">Messaggio</th>
          <th style="width: 14%">Errori</th>
          <th style="width: 12%">Data</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-access>
        <tr>
          <td>
            <button *ngIf="access.responseRawHeaders" pButton type="button"
              class="p-button-outlined history-detail-button"
              (click)="opRes.toggle($event)">
              {{ access.responseRawHeaders | slice:0:16 }}...
            </button>
            <span *ngIf="!access.responseRawHeaders" class="history-muted">—</span>
            <p-overlayPanel #opRes appendTo="body">
              <textarea pInputTextarea rows="8" cols="45" [ngModel]="access.responseRawHeaders" readonly></textarea>
            </p-overlayPanel>
          </td>
          <td><span class="history-ellipsis" [title]="access.category">{{ access.category || '—' }}</span></td>
          <td><span class="history-ellipsis" [title]="access.path">{{ access.path || '—' }}</span></td>
          <td>{{ access.method || '—' }}</td>
          <td><span class="history-status" [class.history-status-error]="access.status >= 400">{{ access.status }}</span></td>
          <td><span class="history-ellipsis" [title]="access.statusMessage">{{ access.statusMessage || '—' }}</span></td>
          <td>
            <button *ngIf="access.errors" pButton type="button"
              class="p-button-outlined history-detail-button"
              (click)="opErr.toggle($event)">
              {{ access.errors | slice:0:16 }}...
            </button>
            <span *ngIf="!access.errors" class="history-muted">—</span>
            <p-overlayPanel #opErr appendTo="body">
              <textarea pInputTextarea rows="8" cols="45" [ngModel]="access.errors" readonly></textarea>
            </p-overlayPanel>
          </td>
          <td>{{ access.firingDate | date:'dd/MM/yyyy HH:mm' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="8" class="history-empty">{{ loading ? '' : 'Nessuna attività trovata' }}</td></tr>
      </ng-template>
    </p-table>
  </div>

  <footer class="history-footer">
    <button pButton type="button" icon="pi pi-chevron-left" label="Precedente"
      class="p-button-outlined history-page-button"
      [disabled]="loading || page === 0" (click)="previousPage()"></button>
    <span class="history-page-info">{{ firstItem }}–{{ lastItem }} / {{ total }}</span>
    <button pButton type="button" icon="pi pi-chevron-right" iconPos="right" label="Successiva"
      class="p-button-outlined history-page-button"
      [disabled]="loading || page >= pageCount - 1" (click)="nextPage()"></button>
  </footer>
</section>
